import type { StateService } from "@uirouter/angularjs";
import type { IScope } from "angular";

import "./EditEquipmentTypeInformation/EditEquipmentTypeInformationComponent";

import type {
    ICommunicationInterface,
    IEquipmentType,
    IEquipmentTypeSlim,
    IResponseWithLoading,
} from "App/Modules/Models";
import type { IModalService } from "App/Modules/Services";

export default class BasicInformationComponentController {
    public static $inject: string[] = ["$scope", "$state", "mmModalService"];

    public equipmentType: IResponseWithLoading<IEquipmentType>;

    public equipmentTypeCommunicationInterfaces: string;

    constructor(
        private readonly $scope: IScope,
        private readonly stateService: StateService,
        private readonly modalService: IModalService,
    ) {}

    public $onChanges() {
        if (this.equipmentType.data) {
            this.equipmentTypeCommunicationInterfaces = this.equipmentType.data.communicationInterfaces
                .map((ci: ICommunicationInterface) => ci.type)
                .join(", ");
            this.$scope.$applyAsync();
        }
    }

    public editBasicInformation() {
        this.modalService
            .open<IEquipmentTypeSlim, void>("irEditEquipmentTypeInformation", this.equipmentType.data)
            .subscribe(
                (editResponse) => {
                    if (editResponse) {
                        this.equipmentType.data = editResponse as IEquipmentType;
                    } else {
                        this.stateService.go("equipmentTypes");
                    }
                },
                (reason) => reason,
            );
    }
}
